import axios from 'axios'
const prefix = `https://m.xinli001.com/`

export const getUser = token =>
  axios.get(`${prefix}ajax/get-user-header${token ? '?token=' + token : ''}`)

// 发送短信验证码
export const checkValidateAliyun = data =>
  axios.post(`${prefix}ajax/check-validate-aliyun`, data)

// 移动端登陆
export const mobileLogin = params =>
  axios.get(`${prefix}ajax/create-or-bind`, { params })
